/**
 * j file collections
 * List file collections with index URLs
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { ConfigService } from '../../services/config.service.js';
import { SettingsService } from '../../services/settings.service.js';
import { FileService } from '../../services/file.service.js';

function formatSize(bytes: number): string {
    if (bytes < 1024) return `${bytes}B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)}KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)}MB`;
}

export function createFileCollectionsCommand(): Command {
    return new Command('collections')
        .description('List file collections')
        .option('--project-id <id>', 'Project ID (default: auto-detect)')
        .option('--personal', 'Force personal scope')
        .option('-j, --json', 'JSON output')
        .action(async (opts) => {
            try {
                const configService = new ConfigService();
                const config = await configService.load();
                if (!config) {
                    console.error(chalk.red('Chưa đăng nhập. Chạy "j auth" trước.'));
                    process.exit(1);
                }

                // Determine scope (same logic as upload)
                let scope: string | undefined;
                let projectId: string | undefined;

                if (opts.personal) {
                    scope = 'personal';
                } else if (opts.projectId) {
                    projectId = opts.projectId;
                } else {
                    const settings = new SettingsService();
                    const detectedProjectId = settings.getProjectId();
                    if (detectedProjectId) {
                        projectId = detectedProjectId;
                    } else {
                        scope = 'personal';
                    }
                }

                const service = new FileService();
                const result = await service.listCollections(config, {
                    scope,
                    projectId,
                    limit: 50,
                });

                if (opts.json) {
                    console.log(JSON.stringify(result, null, 2));
                    return;
                }

                if (result.collections.length === 0) {
                    console.log(chalk.dim('\nKhông có collection nào.\n'));
                    return;
                }

                console.log();
                console.log(chalk.bold(`  ${'ID'.padEnd(6)} ${'Name'.padEnd(20)} ${'Scope'.padEnd(10)} ${'Files'.padEnd(7)} ${'Size'.padEnd(8)} URL`));
                console.log(chalk.dim('  ' + '─'.repeat(80)));

                for (const col of result.collections) {
                    const id = String(col.id).padEnd(6);
                    const name = col.name.substring(0, 18).padEnd(20);
                    const colScope = col.scope.padEnd(10);
                    const files = String(col.fileCount).padEnd(7);
                    const size = formatSize(col.totalSize).padEnd(8);
                    const url = col.indexUrl || chalk.dim('(no index)');

                    console.log(`  ${id} ${name} ${chalk.dim(colScope)} ${files} ${size} ${chalk.cyan(url)}`);
                }

                console.log(chalk.dim(`\n  Total: ${result.total} collections\n`));

            } catch (error) {
                console.error(chalk.red(`Lỗi: ${error instanceof Error ? error.message : String(error)}`));
                process.exit(1);
            }
        });
}
